import type { BasemapsUILabels } from './types'

export const DEFAULT_BASEMAPS_LABELS: BasemapsUILabels = {
  toggle: {
    title: 'Toggle basemaps controls',
  },
  header: {
    title: 'Basemaps',
    actions: {
      close: 'Close',
    },
  },
}
